import { useSubscriptionContext } from '../../../contexts/SubscriptionContext';
import { formatDate, formatCurrency } from '../../../utils/subscriptionUtils';

export const InvoiceHistoryTable = () => {
    const { invoices, isCoreActive } = useSubscriptionContext();

    return (
        <div className="invoice-history">
            <div className="invoice-history-header">
                <h4 className="invoice-history-title">Invoice History</h4>
                {invoices.length > 0 && (
                    <button className="invoice-history-download-all">Download all (CSV)</button>
                )}
            </div>

            {invoices.length === 0 ? (
                <p className="invoice-history-empty">
                    {isCoreActive
                        ? 'No invoices yet. Your first invoice will appear after your billing date.'
                        : 'No invoices yet. Your billing history will appear here once you subscribe to the Core Program.'
                    }
                </p>
            ) : (
                <table className="invoice-history-table">
                    <thead>
                        <tr>
                            <th>INVOICE #</th>
                            <th>DATE</th>
                            <th>DESCRIPTION</th>
                            <th>STATUS</th>
                            <th>AMOUNT</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoices.map((invoice) => (
                            <tr key={invoice.id}>
                                <td className="invoice-number">{invoice.invoiceNumber}</td>
                                <td>{formatDate(invoice.date)}</td>
                                <td>{invoice.description}</td>
                                <td>
                                    <span className={`invoice-status invoice-status--${invoice.status}`}>
                                        {invoice.status === 'paid' && '●'}
                                        {invoice.status === 'failed' && '●'}
                                        {invoice.status === 'pending' && '●'}
                                        {' '}{invoice.status.charAt(0).toUpperCase() + invoice.status.slice(1)}
                                    </span>
                                </td>
                                <td className="invoice-amount">{formatCurrency(invoice.amount)}</td>
                                <td>
                                    {invoice.pdfUrl && (
                                        <a
                                            href={invoice.pdfUrl}
                                            className="invoice-download-link"
                                            download
                                            aria-label={`Download invoice ${invoice.invoiceNumber}`}
                                        >
                                            PDF ↓
                                        </a>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};
